













































































































































import Vue from "vue";
import json2xml from "json2xml";
import { required } from "@isocial-vue/blueprint";
import { form } from "../data/form";
import { FieldType } from "../types/field";
import { sendForm } from "../services/api";
import { getId } from "../helpers";
import Success from "./form/Success.vue";
import DataValue from "./form/DataValue.vue";

export default Vue.extend({
  components: {
    Success,
    DataValue,
  },
  props: {
    type: {
      type: String,
      default: "BE",
    },
    externalData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form,
      valid: false,
      sending: false,
      success: false,
      model: null as any,
      otherCountry: null,
      demand: {
        date: new Date(),
        id: "",
      },
    };
  },
  beforeMount() {
    this.setData();
    // this.setDataFromStorage();
  },
  watch: {
    "$i18n.locale": async function() {
      // Get inputs with error
      // eslint-disable-next-line
      // @ts-ignore
      const $inputs = [...document.querySelectorAll(".v-text-field.error--text input")];

      for (let i = 0; i < $inputs.length; i++) {
        const $input = $inputs[i] as HTMLElement;
        const { id } = $input;
        // Get the Vuetify component v-text-field
        const ref = (this as any).$refs[id]?.[0]?.$children?.[0];
        // Launch validation to update message with new locale
        if (ref) ref.validate();
      }
    },
  },
  methods: {
    countryRules() {
      if (this.model.company.info.country === "be") return [];
      return [required("rtwp.form.error.required")];
    },
    // Getters
    getVisibility(field: FieldType, groupID: string, fieldsetID: string) {
      if (field.type === "spacer") return false;
      if (field.condition) {
        const { condition } = field;
        const value = condition.field.split(".").reduce((val, prop) => val[prop], this.model);
        let isVisible = false;
        if (condition.diff) isVisible = value !== condition.value;
        else isVisible = value === condition.value;
        if (!isVisible) this.model[fieldsetID][groupID][field.id] = "";
        if(!isVisible && condition.notFlex) return isVisible ? true : "notFlex";
        return isVisible;
      }
      return true;
    },
    getTooltip(field: FieldType) {
      if (typeof field.tooltip === "string") return this.$t(field.tooltip);
      return this.$t(`rtwp.form.tooltips.${field.id}`);
    },
    getRules(field: FieldType) {
      const rules = (field as any)[`rules${this.type}`] || field.rules;
      return !rules?.length ? undefined : rules;
    },
    getTemplates(field: FieldType) {
      const templates = (field as any)[`templates${this.type}`] || field.templates;
      return !templates?.length ? [] : templates;
    },
    getReadOnly(field: FieldType) {
      return (field as any)[`readOnly${this.type}`] || field.readOnly;
    },
    getOptionText(field: FieldType, option: any) {
      return this.$t(`rtwp.form.options.${field.id}.${option.value}`);
    },
    getAsterisk(field: FieldType) {
      const required = (field as any)[`required${this.type}`] || field.required;
      return required ? " *" : "";
    },
    // Setters
    setData(reset = false) {
      // Get demand ID
      this.demand.id = getId();
      this.demand.date = new Date();
      this.setModel(reset);
    },
    setModel(reset = false) {
      const model = {} as any;

      this.form.map((fieldset: any) => {
        if (fieldset.id !== "demand") {
          model[fieldset.id] = {};
          fieldset.groups.map((group: any) => {
            model[fieldset.id][group.id] = {};
            group.fields.map((field: any) => {
              if (field.id && field.type !== "spacer") {
                let val: any = "";
                if (reset && this.model && field.keep) val = this.model[fieldset.id][group.id][field.id];
                else if (this.externalData?.[field.id]) {
                  if (field.onInput) val = field.onInput(this.externalData[field.id]);
                  else val = this.externalData[field.id];
                } else if (field.initialValue || field.initialValue === false) {
                  // if (field.type === "country") val = this.$t('rtwp.form.labels.belgium');
                  val = field.initialValue;
                }
                model[fieldset.id][group.id][field.id] = val;
              }
            });
          });
        }
      });

      this.model = model;
    },
    // Events
    onKeydown(e: any, field: FieldType, groupID: any, fieldsetID: any) {
      const { key } = e;

      if (!field.keys || !key || key.length > 1) return;
      if (e.ctrlKey) {
        if (key.match(/x|c|v/g)) {
          if (key === "v") {
            setTimeout(() => {
              const val = this.model[fieldsetID][groupID][field.id];
              this.model[fieldsetID][groupID][field.id] = val.replaceAll(field?.keys?.forbidden, "");
            }, 10);
          }
          return;
        };
      }

      const regex = new RegExp(field.keys.allowed);
      if (!key.match(regex)) {
        e.stopPropagation();
        e.preventDefault();
        setTimeout(() => {
          const val = this.model[fieldsetID][groupID][field.id];
          this.model[fieldsetID][groupID][field.id] = val.replaceAll(field?.keys?.forbidden, "");
        }, 10);
      }
    },
    onInput(e: any, field: FieldType, groupID: any, fieldsetID: any) {
      if (!field.onInput) return;
      const val = field.onInput(e);
      // Cannot directly update value, if we do it, visually value not updated
      // this.model[fieldsetID][groupID][field.id] = val;
      setTimeout(() => {
        this.model[fieldsetID][groupID][field.id] = val;
      }, 10);
    },
    onNewDemand() {
      this.setData(true);
      this.success = false;
    },
    async onSubmit() {
      const $form = this.$refs.form as any;
      const valid = $form.validate();

      if (!valid) {
        setTimeout(() => {
          const firstError = $form.$el.querySelector(".error--text");
          if (firstError) firstError.scrollIntoView({ behavior: "smooth" });
        }, 100);
        return;
      }

      this.sending = true;

      const auth = this.type === "BE";
      const model = JSON.parse(JSON.stringify(this.model));
      // Special values
      model.company.info.CBENumber = model.company.info.country === 'be' ? model.company.info.CBENumber : "0000000000";
      model.company.info.ONSSNumber = model.company.info.country === 'be' ? model.company.info.ONSSNumber : "0000000000";
      model.company.info.country = model.company.info.country === 'be' ? this.$t('rtwp.form.labels.belgium') : this.otherCountry;

      const toXml = {
        form: { ...model },
        attr: {
          xmlns: "urn:be:cin:rtwp:v1",
          authenticated: auth ? "true" : "false",
          id: `_${this.demand.id}`,
          requestedOn: this.demand.date.toISOString(),
        },
      };

      const xml = json2xml(toXml, { header: true, attributes_key: "attr" }).replace(/<contractEndDate\/>/g, "");
      const request = await sendForm(xml, auth);
      const { error } = request;

      if (!error) this.success = true;

      this.sending = false;
    },
  },
});
